import type { BuildingLocaleSettings } from '@/i18n/locale-resolution'

type LocaleBuildingState = {
  userData?: {
    user?: { role?: string }
    // GET /client populates the resident's building; other roles get an id or nothing here
    buildingId?: unknown
  }
  buildingSelector?: {
    activeBuilding?: BuildingLocaleSettings | null
    buildingsLoaded?: boolean
  }
}

/**
 * The building whose language flags apply to the current user (see resolveLanguage):
 * - a resident: their own building, from the GET /client payload;
 * - every other role: the building picked in the navbar selector, so switching building can switch
 *   the language, the same as switching building on mobile.
 *
 * undefined = not loaded yet (keep the language on screen); null = the user has no building (a
 * Trainer, or a staff user with none assigned), which resolves to en-US.
 */
export const selectLocaleBuilding = (
  state: LocaleBuildingState,
): BuildingLocaleSettings | null | undefined => {
  const { userData, buildingSelector } = state

  if (userData?.user?.role === 'Client') {
    const building = userData.buildingId
    return building && typeof building === 'object'
      ? (building as BuildingLocaleSettings)
      : undefined
  }

  if (buildingSelector?.activeBuilding) return buildingSelector.activeBuilding
  return buildingSelector?.buildingsLoaded ? null : undefined
}
